import { REVALIDATE_DATA_NONE } from "@/properties/variables";
import { useEffect, useState } from "react";

interface UseFetchOptionsResult<T> {
  availOptions: string[];
  loading: boolean;
  error: string | null;
}

const useFetchOptions = <T>(
  apiUrl: string,
  propertyKey: keyof T,
  revalidate: number = REVALIDATE_DATA_NONE
): UseFetchOptionsResult<T> => {
  const [options, setOptions] = useState<T[]>([]);
  const [availOptions, setAvailOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true; // prevent state update after unmount

    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(apiUrl, {
          next: {
            revalidate: revalidate,
          },
        });

        if (!res.ok) {
          throw new Error(`Failed to fetch data from ${apiUrl}`);
        }

        const data = await res.json();
        if (isMounted) {
          setOptions(data);
        }
      } catch (err: any) {
        console.error(`Error fetching data from ${apiUrl}:`, err);
        if (isMounted) {
          setOptions([]);
          setError(err.message || "Unknown error");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [apiUrl, revalidate]);

  useEffect(() => {
    const filters: string[] = [];

    options.forEach((item) => {
      const value = item[propertyKey] as string;
      if (typeof value === "string" && !filters.includes(value)) {
        filters.push(value);
      }
    });

    setAvailOptions(filters);
  }, [options, propertyKey]);

  return {
    availOptions,
    loading,
    error,
  };
};

export default useFetchOptions;

/* const [products, setProducts] = useState<Product[]>([]);

  const [availableFilters, setAvailableFilters] = useState<string[]>([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          PRODUCTS_API,{
            next:{
              revalidate: REVALIDATE_DATA_NONE
            }
          }
        );
        if (!res.ok) {
          throw new Error("Failed to fetch products");
        }

        const data = await res.json();
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
        setProducts([]);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const filters: string[] = [];
    products.forEach((product) => {
      if (!filters.includes(product.category)) {
        filters.push(product.category);
      }
    });
    setAvailableFilters(filters);
  }, [products]); */
